import { getDate, getTime } from '../Utils/Helper'
import moment from 'moment'
export const Header = () => {
    // console.log("datetime", moment().format("dddd, MMMM Do YYYY, h:mm:ss a"));
    return (
        <>
            <div className="header_padding">
                <div className="container-fluid">
                    <div className="header_list">
                        <ul>
                            <li>
                                <a href="/">
                                    <img src="/assets/images/home.png" alt="" />
                                </a>
                            </li>
                            {/* <li>
                                <h5 style={{ textTransform: 'uppercase' }}>{getDate()}</h5>
                                <h5>{getTime()}</h5>
                            </li> */}
                        </ul>
                    </div>
                </div>
            </div>

        </>
    )
}